import React from 'react';
import { useLocation } from "react-router-dom";
import { useState, useMemo, useEffect } from 'react';
import { Link } from "react-router-dom";
import { PurchaseModule } from "../components/PurchaseModule";
import { Web3Modal, Web3Button } from "@web3modal/react";
import { useAccount } from "wagmi";

import biofiABI from "../ABI/biofiABI.json";
import purchaseContractABI from "../ABI/purchaseContractABI.json";

import logo from '../images/logo.png';

import "../css/homepage/normalize.css";
import "../css/homepage/webflow.css";
import "../css/homepage/usb-mainsite.webflow.css";

const biofiAddress = "0xd20d431ff2d20c2854785798156f79c779de7ca0";
const purchaseContractAddress = "0xa35efc4ec0ac2a1843db450526d2b009f9e2b9b7";

function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function Payments({ web3ModalProjectId, web3ModalEthereumClient }) {
  const { address } = useAccount();
  let isWalletConnected = (address !== null && typeof (address) !== 'undefined');

  const [dbchainUser, setDbchainUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  let query = useQuery();

  useEffect(() => {
    if (query.get('dbchainUser') !== null && query.get('dbchainUser') !== '' && address !== null) {
      let dbChainAddress = query.get('dbchainUser');
      setDbchainUser(dbChainAddress);
    }
    return;
  }, []);

  useEffect(() => {
    setIsLoading(false);
  }, [dbchainUser]);

  return (
    <>
        {/*Header Navbar */}
      <div className="page-wrapper">
      <div data-collapse="medium"
          data-animation="over-right"
          data-duration={400}
          data-w-id="58db7844-5919-d71b-dd74-2323ed8dffe9"
          data-easing="ease"
          data-easing2="ease"
          role="banner"
          className="header w-nav"
        >
          <div className="container-default w-container">
            <div className="header-wrapper">
              <div
                data-w-id="a3e68005-48fe-fa9e-c964-745ec27593aa"
                className="split-content header-right"
              >
                <Link to="/" className="header-logo-link w-nav-brand">
                  <img
                    src={require("../images/UniSafeBox_Logo.png")}
                    alt=""
                    className="header-logo-2"
                  />
                </Link>
              </div>
              
              <div>
                  <input type="checkbox" id="menu-toggle" />
                  <label for="menu-toggle" class="hamburger-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                  </label>
                  <nav id="mobile-nav">
                  <ul role="list" className="header-navigation">
                    <li className="nav-item-wrapper first">
                      <Link to="/" className="nav-link-2">
                        Home
                      </Link>
                    </li>
                    <li className="nav-item-wrapper">
                      <Link to="/requestLink" className="nav-link-2">
                        Pay for USB
                      </Link>
                    </li>
                    <li className="nav-item-wrapper header-button-wrapper">
                      <div className="nav-button-wrapper">
                        <a
                          href="https://finnovant.s3.amazonaws.com/UniSafeBox-Android.apk"
                          className="button-primary-2 full-width w-button"
                        >
                          Download Now
                        </a>
                      </div>
                    </li>
                  </ul>
                  </nav>
                </div>
              
              <div className="split-content header-left">
                <div className="nav-button-wrapper hide-in-mobile">
                  <a href="https://finnovant.s3.amazonaws.com/UniSafeBox-Android.apk" className="button-primary-2 small w-button">
                    Download Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-2 wf-section">
        <div className="usb_payinner">
          <header>
            <h1 className="heading-2">
              UniSafeBox Subscription
            </h1>
          </header>
          <div className="usb_paymentproc2">
            {
              !isLoading ? (
                dbchainUser !== null && dbchainUser.length === 45 ? (
                  <>
                    <Web3Button icon="show" label="Connect Wallet" balance="hide" />

                    <hr />

                    {
                      isWalletConnected ? (
                        <>
                          <PurchaseModule tokenAddress={biofiAddress} tokenABI={biofiABI} purchaseContractAddress={purchaseContractAddress} purchaseContractABI={purchaseContractABI} dbchainUser={dbchainUser} />
                        </>
                      ) : (
                        <h3>Connect wallet to pay for your subscription</h3>
                      )
                    }
                  </>
                ) : (
                  <>
                    <h2>Invalid Payment link</h2>
                    <span>Make sure to use the link sent to you by email.</span>
                    <br />
                  </>
                )
              ) : (
                <span>Loading...</span>
              )
            }

          </div>
        </div>
      </div>
      </div>

      <footer className="footer">
          <div className="container-default">
            <div className="w-layout-grid footer-grid">
              <div
                id="w-node-_545d2dbf-8143-2662-0998-a356a1027525-ae2f46c5"
                className="footer-column"
              >
                <a
                  href="#"
                  className="footer-logo-container mg-bottom-24px w-inline-block"
                >
                  <img
                    src={require("../images/UniSafeBox_Logo.png")}
                    alt=""
                    className="footer-logo"
                  />
                </a>
                <p className="mg-bottom-32px">
                  Secure your assets with UniSafeBox Powered Biometric
                  Financial.
                  <br />
                </p>
                <div className="social-links-wrapper" />
              </div>
              <div
                id="w-node-_8f0dde0c-ad87-3903-db5c-1a8dc74f8208-ae2f46c5"
                className="footer-column middle"
              >
                <div className="footer-nav-main-wrapper">
                  <div className="footer-nav-wrapper">
                    <ul role="list" className="footer-nav" />
                  </div>
                </div>
              </div>
            </div>
            <div className="divider bg-neutral-600" />
            <div className="footer-bottom-content">
              <div>
                Copyright © 2023 UniSafeBox - powered by <a href="https://www.biometricfinancial.org" alt="Biofi">Biometric Financial</a> 
              </div>
            </div>
          </div>
        </footer>

      <Web3Modal
        projectId={web3ModalProjectId}
        ethereumClient={web3ModalEthereumClient}
        themeMode={"dark"}
        themeColor={"blackWhite"}
      />
    </>
  );

}